<template>
  <div
    class="information-container"
    id="information-mobile-modal"
  >
    <div class="accordion" id="information">
      <div class="accordion-item" v-if="showInformation">
        <h2 class="accordion-header" id="information-header-accordion">
          <button
            class="accordion-button"
            data-bs-toggle="collapse"
            data-bs-target="#information-content">
            <div class="accordion-icon"><i class="fa fa-file information-icon" aria-hidden="true"></i></div>Information
          </button>
        </h2>
        <div
          id="information-content"
          class="accordion-collapse collapse show"
          data-bs-parent="#information"
        >
          <div class="accordion-body">
            <p>
              Please contact
              <a class="contact-link-p" href="mailto:SARAdmin@microchip.com">SARAdmin@microchip.com</a>
              or
              <a class="contact-link-p" href="https://www.microchip.com/en-us/support"
                >https://www.microchip.com/en-us/support/</a
              >
              for assistance and guidance.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="accordion" id="resources">
      <div class="accordion-item" v-if="showResources">
        <h2 class="accordion-header" id="resources-header-accordion">
          <button
            class="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#resources-content"
          >
          <div class="accordion-icon"><i class="fa fa-info-circle information-icon" aria-hidden="true"></i></div>Resources
          </button>
        </h2>
        <div
          id="resources-content"
          class="accordion-collapse collapse"
          data-bs-parent="#resources"
        >
          <div class="accordion-body">
            <p>
              <a
                href="https://www.microchip.com/en-us/development-tool/DV164045"
                >ICD 4 Documentation</a
              >
            </p>
            <p>
              <a
                href="https://www.microchip.com/en-us/development-tool/PG164140"
                >Pickit 4 Documentation</a
              >
            </p>
            <p>
              <a
                href="https://www.microchip.com/en-us/tools-resources/debug/programmers-debuggers/development-tool-accessories"
                >Emulator and Debugger Accessories</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["showInformation", "showResources"],
};
</script>
<style scoped>
/* Keep the contact links (email + support URL) on one line so they don't
   break mid-word (e.g. the support URL splitting after "en-us"). */
.contact-link-p {
  white-space: nowrap;
}
</style>